// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__HAJBx","centerDiv":"MainPage_centerDiv__CuUBJ","modal":"MainPage_modal__9ui+5"};